<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div
    class="modal-container"
    v-if="show"
    ref="overlay"
    @click="overlayHandler($event)"
    :class="[customClass]"
  >
    <div ref="modalContent"
      class="modal-container__content"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      @keydown="trapFocus">
      <slot name="title"></slot>
      <button ref="closeButton" class="modal-container__close" @click="handleClose">
        <svg aria-hidden="true" class="icon">
          <use
            xlink:href="#close"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          ></use>
        </svg>
      </button>
      <slot v-if="isvideoPopup" :modalOptions="modalOptions" />
      <slot v-else :toggle="toggle"></slot>
    </div>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
const USER_INTERACTION_EVENT_TYPES_ALL = [
  'mousemove',
  'scroll',
  'keyup',
  'keydown',
  'touchstart',
  'click',
];

export default {
  name: 'the-modal',
  props: {
    settings: {
      type: Object,
      required: false,
      default: null,
    },
    customClass: {
      type: String,
      required: false,
      default: '',
    },
    modalid: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      show: false,
      modalOptions: null,
      checkSuppressIfEmailRedirect: false,
      isCurrentPageInDisplayPages: false,
      previousFocus: null,
    };
  },
  mounted() {
    eventBus.$on(this.modalid, this.showModal);
    document.addEventListener('keydown', this.onEscKeydown);
    this.settings && this.urlDecodeData();
    this.isCurrentPageInDisplayPages =
    this.settings && this.currentPageInDisplayPages();
    document.addEventListener('focusin', this.handleFocusIn);
    if (this.modalAutoShow) {
      const done = () => {
        USER_INTERACTION_EVENT_TYPES_ALL.forEach((event) => {
          window.removeEventListener(event, done);
        });
        this.setLocalStorageItem();
        this.hasTimer();
      };

      USER_INTERACTION_EVENT_TYPES_ALL.forEach((event) => {
        window.addEventListener(event, done);
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onEscKeydown);
  },
  computed: {
    modalAutoShow() {
      return this.settings &&
        this.settings.enablePopup &&
        !this.hideUserHasSignedIn &&
        !this.hasClosedModalCookie &&
        !this.checkSuppressIfEmailRedirect &&
        this.isCurrentPageInDisplayPages
        ? true
        : false;
    },
    isvideoPopup() {
      return (
        this.modalOptions &&
        this.modalOptions.videoId != null &&
        this.modalOptions.videoId != ''
      );
    },
    hideUserHasSignedIn() {
      const localUserSignedIn = localStorage.getItem('subscribed');
      const localUserSignedInVal = JSON.parse(localUserSignedIn);
      return this.settings.suppressIfSignedUp && localUserSignedInVal;
    },
    hasClosedModalCookie() {
      return document.cookie.indexOf('hasClosedModal') > -1 ? true : false;
    },
  },
  methods: {
    currentPageInDisplayPages() {
      const currentPage = window.location.pathname;
      return this.settings.displayPages.includes(currentPage);
    },
    urlDecodeData() {
      let params = new URLSearchParams(document.location.search);
      let sitecoreUrlSetting = this.settings.utmParameters;

      sitecoreUrlSetting = sitecoreUrlSetting.split('|').filter((x) => x != '');
      const sitecoreUrlObject = [];
      sitecoreUrlSetting.forEach((item) => {
        const data = item.split('=');
        sitecoreUrlObject.push({
          key: data[0],
          value: data[1],
        });
      });

      let allItems = true;
      sitecoreUrlObject.forEach((item) => {
        const urlValue = params.get(item.key);
        if (urlValue) {
          if (item.value.startsWith('SHA256')) return;
          if (urlValue === item.value) return;

          allItems = false;
        }
        allItems = false;
      });

      this.checkSuppressIfEmailRedirect =
        allItems && this.settings.suppressIfEmailRedirect;
    },
    handleClose() {
      this.toggle();
      this.closeModal();
    },
    toggle() {
      this.show = !this.show;

      if (!this.show) {
        this.unlockBackground();

        this.$nextTick(() => {
          //return focus to opener
          if (this.previousFocus) {
            this.previousFocus.focus();
          } else {
            //first focusable in page
            const first = document.querySelector(
              'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );

            first?.focus();
          }
        });
      }
      // only if user is closing the modal and has suppresCounter settings on
      if (!this.show && this.settings) {
        let counter = localStorage.getItem('counter');
        const localUserSignedIn = localStorage.getItem('subscribed');
        const hideFromSignedInUser =
          this.settings.suppressIfSignedUp && localUserSignedIn;

        this.setLocalCookieItem();
        localStorage.setItem('counter', ++counter);
        let closedModalCookie =
          document.cookie.indexOf('hasClosedModal') > -1 ? true : false;
        if (!closedModalCookie && !hideFromSignedInUser) {
          this.hasTimer();
        }
      }
    },

    showModal(options = {}) {
      this.modalOptions = { ...options };

      this.previousFocus = document.activeElement; // 👈 SAVE TRIGGER

      this.show = true;

      this.$nextTick(() => {
        this.lockBackground();
        this.$refs.closeButton?.focus();
      });
    },

    closeModal() {
      eventBus.$emit('modalCloseEvent');
    },

    overlayHandler(event) {
      if (event.target === this.$refs.overlay) {
        this.toggle();
      }
    },

    onEscKeydown(event) {
      if (event.key === 'Escape' && this.show) {
        this.toggle();
      }
    },

    setLocalStorageItem() {
      const localCounter = localStorage.getItem('counter');
      if (!localCounter) {
        localStorage.setItem('counter', 0);
      }
    },

    setLocalCookieItem() {
      let exdate = new Date();
      exdate.setTime(exdate.getTime() + 7 * 24 * 60 * 60 * 1000);
      document.cookie =
        'hasClosedModal=true; expires=' + exdate.toGMTString() + ';';
    },

    hasTimer() {
      const timerValue = this.settings.timer * 1000;
      const localCounter = localStorage.getItem('counter');
      setTimeout(() => {
        if (this.settings.timer && localCounter < 2) {
          this.showModal();
        }
      }, timerValue);
    },

    handleFocusIn(event) {
      if (!this.show) return;

      const modal = this.$refs.modalContent;

      if (modal && !modal.contains(event.target)) {
        event.stopPropagation();
        event.preventDefault();

        this.$refs.closeButton?.focus();
      }
    },

    trapFocus(event) {
      if (event.key !== 'Tab') return;

      const modal = this.$refs.modalContent;

      const focusableElements = modal.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, iframe, [tabindex]:not([tabindex="-1"])'
      );

      if (!focusableElements.length) {
        event.preventDefault();
        this.$refs.closeButton?.focus();
        return;
      }

      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];

      const active = document.activeElement;

      if (event.shiftKey) {
        if (active === first || !modal.contains(active)) {
          event.preventDefault();
          last.focus();
        }
      } else {
        if (active === last || !modal.contains(active)) {
          event.preventDefault();
          first.focus();
        }
      }
    },

    lockBackground() {
      this._previouslyDisabled = [];

      const all = document.querySelectorAll('body *');

      all.forEach(el => {
        if (this.$refs.overlay?.contains(el)) return;

        if (el.hasAttribute('inert')) return;

        this._previouslyDisabled.push({
          el,
          tabindex: el.getAttribute('tabindex'),
        });

        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      });
    },

    unlockBackground() {
      (this._previouslyDisabled || []).forEach(({ el, tabindex }) => {
        if (tabindex === null) {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', tabindex);
        }

        el.removeAttribute('aria-hidden');
      });

      this._previouslyDisabled = [];
    },

  },
};
</script>
